export default __webpack_public_path__ + "static/media/message_dark_blue.3bcbb922.svg";